import { Component, Inject, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { RouteController } from '@shared/src/controllers/route/route.controller';
import { AcquireRouteWizardCtrlDto } from '@shared/src/dtos/route/acquire/AcquireRouteWizardCtrlDto';

@Component({
	selector: 'shared-route-acquire-wizard',
	templateUrl: './shared.route.acquire.wizard.html',
	styleUrls: ['./shared.route.acquire.wizard.scss']
})
export class SharedRouteAcquireWizard implements OnInit {

	public static SLICECOUNTINITIAL: number = 100;
	public static SLICECOUNTMORE: number = 100;

	@Output() finish = new EventEmitter<boolean>();

	public useIonic: boolean = false;
	constructor(public routeController: RouteController,
		@Inject('HomeController') protected homeController: HomeController) {

		if (homeController.useIonic)
			this.useIonic = homeController.useIonic();

	}

	ngOnInit(): void {
		this.onStart();
	}

	public _wizard: AcquireRouteWizardCtrlDto;
	@Input()
	public get wizard(): AcquireRouteWizardCtrlDto {
		return this._wizard;
	}
	public set wizard(value: AcquireRouteWizardCtrlDto) {
		if (this._wizard === value)
			return;
		this._wizard = value;
	}

	onStart() {
		this.routeController.getWizardAcquireRoutesStart(false).subscribe(e => {
			this.wizard = AcquireRouteWizardCtrlDto.build(e);
		});
	}

	onPrevious() {
		this.routeController.wizardAcquireRoutesPrevious(this.wizard, false).subscribe(e => {
			this.wizard = AcquireRouteWizardCtrlDto.build(e);
		});
	}

	onNext() {
		this.routeController.wizardAcquireRoutesNext(this.wizard, false).subscribe(e => {
			this.wizard = AcquireRouteWizardCtrlDto.build(e);
		});
	}

	onPartnerSelected() {
		this.onNext();
	}

	onFinish() {
		this.routeController.wizardAcquireRoutesFinish(this.wizard, true).subscribe(e => {
			this.wizard = AcquireRouteWizardCtrlDto.build(e);
			this.finish.next(true);
		});
	}
}
